import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/Login';
import AdminDashboard from './pages/Admin/AdminDashboard';
import CreateUser from './pages/Admin/CreateUser';
import SalesDashboard from './pages/Sales/SalesDashboard';
import AddCustomer from './pages/Sales/AddCustomer';
import EditCustomer from './pages/Sales/EditCustomer';
import SearchCustomer from './pages/Sales/SearchCustomer';
import SalesOrderList from './pages/Sales/SalesOrderList';
import CreateSalesOrder from './pages/Sales/CreateSalesOrder';
import SalesJobList from './pages/Sales/SalesJobsList';
import OperationsDashboard from './pages/Operations/OperationsDashboard';
import JobOrdersList from './pages/Operations/JobOrdersList';
import TeamManagement from './pages/Operations/TeamManagement';
import VehicleMachineryManagement from './pages/Operations/VehicleMachineryManagement';
import CustomerChat from './pages/Operations/CustomerChat';
import AccountsDashboard from './pages/Accounts/AccountDashboard';
import HomeScreen from './pages/Home';
import ProtectedRoute from './components/PrivateRoute';
import AdminLayout from './layouts/AdminLayout';
import AdminCompletedJobs from './pages/Admin/AdminCompletedJobs';
import AdminJobPerformance from './pages/Admin/JobPerformance';
import AdminTeamAnalytics from './pages/Admin/TeamAnalytics';
import AdminJobDetails from './pages/Admin/AdminJobDetails';
import CILayout from './layouts/CILayout';
import { CleanDataProvider } from './context/CleanDataContext';
import CIDashboard from './pages/CI/CIDashboard';
import AddCIClient from './pages/CI/AddCIClient';
import ListCIClients from './pages/CI/ListCIClients';
import SiteAssignments from './pages/CI/SiteAssignments';
import SitesManagement from 'pages/CI/SiteManagement';
import CommercialTeamManagement from 'pages/CI/TeamManagement';
import TeamSchedulingCalendar from 'pages/CI/TeamSchedulingCalender';
import AttendanceDashboard from 'pages/CI/AttendanceDashboard';
import FSRPhotos from 'pages/CI/FSRPhotos';
import CIAdminPettyCash from 'pages/CI/PettyCash';
import CIComplianceLog from 'pages/CI/ComplianceLog';
import CIEHSReports from 'pages/CI/EHSReports';
import CITeamPerformance from 'pages/CI/TeamPerformance';
import CIMandateConfig from 'pages/CI/MandateConfig';
import CIAttendancePunches from 'pages/CI/AttendancePunches';
import ClientSiteAssignments from './pages/CI/ClientAssignments';
import CITasksData from './pages/CI/CITasksData';
import JobHistory from 'pages/CI/JobHistory';
import CISLDEditor from 'pages/CI/SLDEditor';
import CISLDReport from 'pages/CI/SLDReport';
import AdminIoT from 'pages/Admin/Admin-IoT';
import ClientLocator from 'pages/Admin/ClientLocator';
import NovaDailyTracker from 'pages/Admin/DailyReport';
import AdminEHS from 'pages/Admin/AdminEHS';
import AdminEmployeeEvaluation from 'pages/Admin/AdminEmployeeEvaluation';
import CustomerJobHistory from './pages/CustomerPortal/CustomerJobHistory';
import CustomerPortal from 'pages/CustomerPortal/CustomerDashboard';
import CustomerProfile from 'pages/CustomerPortal/CustomerProfile';
import UserManagement from 'pages/Admin/UserManagement';
import PasswordResetRequests from 'pages/Admin/PasswordResetRequests';
import CommercialDashboard from 'pages/Admin/CiDashboard';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CommercialClientList from 'pages/Admin/CommercialClientsList';
import AdminSalesDashboard from './pages/Admin/SalesDashboard';
import HiringForm from 'pages/Employeeform/EmployeeForm';
import Part2Form from 'pages/Employeeform/EmployeeQuestion';
import EmployeeDashboard from 'pages/Employeeform/EmployeeDashboard';
import NovaDashboard from 'pages/CI/NovaaTracking';
import HiredEmployee from 'pages/Employeeform/HiredEmployee';
import OnBoardingForm from 'pages/Employeeform/NovaOnBoardingForm';
import NarrativeBuilder from 'pages/Employeeform/NarrativeBuilder';
import PettyCashRequestForm from 'pages/Operations/PettyCash';
import FinanceDashboard from 'pages/Accounts/PettyCash';
import CIFinancePettyCash from 'pages/Accounts/CIPettyCash';
import NovaaWristTracking from 'pages/CI/WristDataDashboard';
import PurchaseRequestForm from 'pages/Operations/PurchaseRequestForm';
import NovaEmployeeDashboard from 'pages/Employeeform/OnBoardingDashboard';

import EmployeeEvaluation from 'pages/Employeeform/EmployeeEvaluation';
import AdminEmployeePage from 'pages/Employeeform/EmployeeProfile';
import EvaluationDashboard from 'pages/Operations/EvaluationDashboard';
import OpsHub from 'pages/Hub/OpsHub';


// ── Mideast Portal ─────────────────────────────────────────
import MideastLogin       from './pages/MideastPortal/MideastLogin';
import MideastAdminLayout from './components/Mideast/MideastAdminLayout';


// Mideast screens — create these as empty placeholders for now,
// we will build them screen by screen
import MideastDashboard from './pages/MideastPortal/Admin/MEDashboard';
import MideastClients   from './pages/MideastPortal/Admin/MEClients';
import MideastSites     from './pages/MideastPortal/Admin/MESites';
import MideastTeams     from './pages/MideastPortal/Admin/METeams';
import MideastSchedule  from './pages/MideastPortal/Admin/MESchedule';
import MideastUsers     from './pages/MideastPortal/Admin/MEUsers';
import MideastJobs      from './pages/MideastPortal/Admin/MEJobs';


// Mideast customer dashboard
import MideastCustomerLayout    from './components/Mideast/MideastCustomerLayout';
import MideastCustomerDashboard from './pages/MideastPortal/Customer/MECustomerDashboard';
// ───────────────────────────────────────────────────────────


// Mideast protected route — checks mideast_token + type
// completely separate from the main ProtectedRoute
const MideastAdminRoute = ({ children }) => {
  const token = localStorage.getItem('mideast_token');
  const raw   = localStorage.getItem('mideast_user');
  if (!token || !raw) return <Navigate to="/me-login" replace />;
  try {
    const user = JSON.parse(raw);
    if (user.type !== 'mideast-admin') return <Navigate to="/me-login" replace />;
  } catch {
    return <Navigate to="/me-login" replace />;
  }
  return children;
};


const MideastCustomerRoute = ({ children }) => {
  const token = localStorage.getItem('mideast_token');
  const raw   = localStorage.getItem('mideast_user');
  if (!token || !raw) return <Navigate to="/me-login" replace />;
  try {
    const user = JSON.parse(raw);
    if (user.type !== 'mideast-customer') return <Navigate to="/me-login" replace />;
  } catch {
    return <Navigate to="/me-login" replace />;
  }
  return children;
};


function App() {
  return (
    <CleanDataProvider>
      <Routes>


        {/* ── Public ───────────────────────────────────── */}
        <Route path="/"                          element={<LoginPage />} />
        <Route path="/me-login"                  element={<MideastLogin />} />
        <Route path="/employee-form"             element={<HiringForm />} />
        <Route path="/employee-question-form"    element={<Part2Form />} />
        <Route path="/novaa-tracker"             element={<NovaDashboard />} />
        <Route path="/hired-employees"           element={<HiredEmployee />} />
        <Route path="/narrative-builder"         element={<NarrativeBuilder />} />
        <Route path="/create-user"               element={<CreateUser />} />
        <Route path="/petty-cash"                element={<PettyCashRequestForm />} />
        <Route path="/wrist-data"                element={<NovaaWristTracking />} />
        <Route path="/on-boarding-dashboard"     element={<NovaEmployeeDashboard />} />
        <Route path="/employee"     element={<EmployeeEvaluation/>} />
        <Route path="/evaluation-dashboard"     element={<EvaluationDashboard/>} />

        {/* Operations Hub — hidden, URL-only page (no menu link, no auth). */}
        <Route path="/client-locator-9x7k3p"    element={<OpsHub />} />



        {/* ── Main Admin Layout ─────────────────────────── */}
        <Route element={<AdminLayout />}>
          <Route path="/dashboard/admin" element={
            <ProtectedRoute allowedRoles={['admin']}><AdminDashboard /></ProtectedRoute>
          }/>
          <Route path="/dashboard/sales" element={
            <ProtectedRoute allowedRoles={['sales','admin']}><SalesDashboard /></ProtectedRoute>
          }/>
          <Route path="/dashboard/operations" element={
            <ProtectedRoute allowedRoles={['operations']}><OperationsDashboard /></ProtectedRoute>
          }/>
          <Route path="/dashboard/accounts" element={
            <ProtectedRoute allowedRoles={['accounts']}><AccountsDashboard /></ProtectedRoute>
          }/>
          <Route path="/accounts/petty-cash-requests" element={
            <ProtectedRoute allowedRoles={['accounts','admin']}><FinanceDashboard /></ProtectedRoute>
          }/>
          <Route path="/accounts/ci-petty-cash" element={
            <ProtectedRoute allowedRoles={['accounts','admin']}><CIFinancePettyCash /></ProtectedRoute>
          }/>
          <Route path="/accounts/onboardingform-dashboard" element={
            <ProtectedRoute allowedRoles={['accounts','admin']}><NovaEmployeeDashboard /></ProtectedRoute>
          }/>
          <Route path="/dashboard/customer" element={
            <ProtectedRoute allowedRoles={['customer']}><CustomerPortal /></ProtectedRoute>
          }/>
          <Route path="/dashboard/commercial" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><CIDashboard /></ProtectedRoute>
          }/>
          <Route path="/home" element={
            <ProtectedRoute allowedRoles={['accounts','sales','operations','admin','customer']}><HomeScreen /></ProtectedRoute>
          }/>
          <Route path="/sales/add-customer" element={
            <ProtectedRoute allowedRoles={['sales','admin']}><AddCustomer /></ProtectedRoute>
          }/>
          <Route path="/sales/edit-customer/:id" element={
            <ProtectedRoute allowedRoles={['sales','admin']}><EditCustomer /></ProtectedRoute>
          }/>
          <Route path="/sales/search-customers" element={
            <ProtectedRoute allowedRoles={['sales','admin']}><SearchCustomer /></ProtectedRoute>
          }/>
          <Route path="/sales/list-sales-orders" element={
            <ProtectedRoute allowedRoles={['sales','admin']}><SalesOrderList /></ProtectedRoute>
          }/>
          <Route path="/sales/sales-order/create/:id" element={
            <ProtectedRoute allowedRoles={['sales','admin']}><CreateSalesOrder /></ProtectedRoute>
          }/>
          <Route path="/sales/list-job-orders/" element={
            <ProtectedRoute allowedRoles={['sales','admin']}><SalesJobList /></ProtectedRoute>
          }/>
          <Route path="/operations/list-job-orders" element={
            <ProtectedRoute allowedRoles={['operations','admin']}><JobOrdersList /></ProtectedRoute>
          }/>
          <Route path="/operations/team-management" element={
            <ProtectedRoute allowedRoles={['operations','admin']}><TeamManagement /></ProtectedRoute>
          }/>
          {/* Residential customer support chat. The backend enforces the same
              two roles in requireSupportAgent — this guard is UX, not security. */}
          <Route path="/operations/customer-chat" element={
            <ProtectedRoute allowedRoles={['operations','admin']}><CustomerChat /></ProtectedRoute>
          }/>
          <Route path="/operations/vehicle-machinery-management" element={
            <ProtectedRoute allowedRoles={['operations','admin']}><VehicleMachineryManagement /></ProtectedRoute>
          }/>
          <Route path="/operations/employee-management-form" element={
            <ProtectedRoute allowedRoles={['operations','admin']}><HiringForm /></ProtectedRoute>
          }/>
          <Route path="/operations/employee-management" element={
            <ProtectedRoute allowedRoles={['operations','admin']}><EmployeeDashboard /></ProtectedRoute>
          }/>
          <Route path="/operations/hired-employee" element={
            <ProtectedRoute allowedRoles={['operations','admin']}><HiredEmployee /></ProtectedRoute>
          }/>
          <Route path="/operations/onboarding-form" element={
            <ProtectedRoute allowedRoles={['operations','admin']}><OnBoardingForm /></ProtectedRoute>
          }/>
          <Route path="/operations/petty-cash" element={
            <ProtectedRoute allowedRoles={['operations','admin']}><PettyCashRequestForm /></ProtectedRoute>
          }/>
          <Route path="/operations/purchase-request" element={
            <ProtectedRoute allowedRoles={['operations','admin']}><PurchaseRequestForm /></ProtectedRoute>
          }/>
          <Route path="/operations/profile-page" element={
            <ProtectedRoute allowedRoles={['operations','admin']}><AdminEmployeePage /></ProtectedRoute>
          }/>
          <Route path="/admin/completed-job-orders" element={
            <ProtectedRoute allowedRoles={['admin']}><AdminCompletedJobs /></ProtectedRoute>
          }/>
          <Route path="/admin/job-performance" element={
            <ProtectedRoute allowedRoles={['admin']}><AdminJobPerformance /></ProtectedRoute>
          }/>
          <Route path="/admin/team-analytics" element={
            <ProtectedRoute allowedRoles={['admin']}><AdminTeamAnalytics /></ProtectedRoute>
          }/>
          <Route path="/admin/list-clients" element={
            <ProtectedRoute allowedRoles={['admin']}><CommercialClientList /></ProtectedRoute>
          }/>
          <Route path="/admin/job-details/:id" element={
            <ProtectedRoute allowedRoles={['admin']}><AdminJobDetails /></ProtectedRoute>
          }/>
          <Route path="/admin/client-locator" element={
            <ProtectedRoute allowedRoles={['admin']}><ClientLocator /></ProtectedRoute>
          }/>
          <Route path="/admin/accounts-dashboard" element={
            <ProtectedRoute allowedRoles={['admin']}><AccountsDashboard /></ProtectedRoute>
          }/>
          <Route path="/admin/sales-dashboard" element={
            <ProtectedRoute allowedRoles={['admin']}><AdminSalesDashboard /></ProtectedRoute>
          }/>
          <Route path="/admin/operations-dashboard" element={
            <ProtectedRoute allowedRoles={['admin']}><OperationsDashboard /></ProtectedRoute>
          }/>
          <Route path="/admin/create-user" element={
            <ProtectedRoute allowedRoles={['admin']}><CreateUser /></ProtectedRoute>
          }/>
          <Route path="/admin/user-management" element={
            <ProtectedRoute allowedRoles={['admin']}><UserManagement /></ProtectedRoute>
          }/>
          <Route path="/admin/password-reset-requests" element={
            <ProtectedRoute allowedRoles={['admin']}><PasswordResetRequests /></ProtectedRoute>
          }/>
          <Route path="/admin/commercial-dashboard" element={
            <ProtectedRoute allowedRoles={['admin']}><CommercialDashboard /></ProtectedRoute>
          }/>
          <Route path="/admin/iot" element={
            <ProtectedRoute allowedRoles={['admin']}><AdminIoT /></ProtectedRoute>
          }/>
          <Route path="/admin/daily-reporting-dashboard" element={
            <ProtectedRoute allowedRoles={['admin']}><NovaDailyTracker /></ProtectedRoute>
          }/>
          <Route path="/admin/ehs" element={
            <ProtectedRoute allowedRoles={['admin']}><AdminEHS /></ProtectedRoute>
          }/>
          <Route path="/admin/employee-evaluation" element={
            <ProtectedRoute allowedRoles={['admin']}><AdminEmployeeEvaluation /></ProtectedRoute>
          }/>
          <Route path="/reports" element={<div>Reports Page</div>} />
          <Route path="/hr"      element={<div>HR Page</div>} />
        </Route>


        {/* ── CI Module ─────────────────────────────────── */}
        <Route path="/commercial" element={<CILayout />}>
          <Route index element={<CIDashboard />} />
          <Route path="add-clients" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><AddCIClient /></ProtectedRoute>
          }/>
          <Route path="list-clients" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><ListCIClients /></ProtectedRoute>
          }/>
          <Route path="novaa-tracker" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><NovaDashboard /></ProtectedRoute>
          }/>
          <Route path="site-assignments/:siteId" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><SiteAssignments /></ProtectedRoute>
          }/>
          <Route path="site-management/" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><SitesManagement /></ProtectedRoute>
          }/>
          <Route path="sld-diagrams" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><CISLDEditor /></ProtectedRoute>
          }/>
          <Route path="sld-report" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><CISLDReport /></ProtectedRoute>
          }/>
          <Route path="team-management/" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><CommercialTeamManagement /></ProtectedRoute>
          }/>
          <Route path="team-calender/" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><TeamSchedulingCalendar /></ProtectedRoute>
          }/>
          <Route path="attendance/" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><AttendanceDashboard /></ProtectedRoute>
          }/>
          <Route path="fsr-photos/" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><FSRPhotos /></ProtectedRoute>
          }/>
          <Route path="petty-cash/" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><CIAdminPettyCash /></ProtectedRoute>
          }/>
          <Route path="compliance/" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><CIComplianceLog /></ProtectedRoute>
          }/>
          <Route path="ehs/" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><CIEHSReports /></ProtectedRoute>
          }/>
          <Route path="performance/" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><CITeamPerformance /></ProtectedRoute>
          }/>
          <Route path="employee-evaluation" element={
            <ProtectedRoute allowedRoles={['ci_admin','admin']}><EvaluationDashboard /></ProtectedRoute>
          }/>
          <Route path="mandate-config/" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><CIMandateConfig /></ProtectedRoute>
          }/>
          <Route path="attendance-punches/" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><CIAttendancePunches /></ProtectedRoute>
          }/>
          <Route path="job-history/" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><JobHistory /></ProtectedRoute>
          }/>
          <Route path="client-assignments/" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><ClientSiteAssignments /></ProtectedRoute>
          }/>
          <Route path="tasks-data" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><CITasksData /></ProtectedRoute>
          }/>
          <Route path="Wrist-data" element={
            <ProtectedRoute allowedRoles={['ci_admin']}><NovaaWristTracking /></ProtectedRoute>
          }/>
        </Route>


        {/* ── Customer Portal ───────────────────────────── */}
        <Route path="/customer" element={<CILayout />}>
          <Route index element={<CustomerPortal />} />
          <Route path="job-history/" element={
            <ProtectedRoute allowedRoles={['customer']}><CustomerJobHistory /></ProtectedRoute  >
          }/>
          <Route path="customer-profile/" element={
            <ProtectedRoute allowedRoles={['customer']}><CustomerProfile /></ProtectedRoute>
          }/>
        </Route>


        {/* ── Mideast Admin Portal ──────────────────────── */}
        <Route path="/me/admin" element={
          <MideastAdminRoute>
            <MideastAdminLayout />
          </MideastAdminRoute>
        }>
          <Route index                element={<MideastDashboard />} />
          <Route path="clients"       element={<MideastClients />} />
          <Route path="sites"         element={<MideastSites />} />
          <Route path="teams"         element={<MideastTeams />} />
          <Route path="users"         element={<MideastUsers />} />
          <Route path="schedule"      element={<MideastSchedule />} />
          <Route path="jobs"          element={<MideastJobs />} />
        </Route>
 
        {/* ── Mideast Customer Portal ───────────────────── */}
        <Route path="/me/dashboard" element={
          <MideastCustomerRoute>
            <MideastCustomerLayout />
          </MideastCustomerRoute>
        }>
          <Route index element={<MideastCustomerDashboard />} />
        </Route>


      </Routes>


      <ToastContainer position="top-right" autoClose={3000} />
    </CleanDataProvider>
  );
}


export default App;
